export default __webpack_public_path__ + "static/media/0.459b812a.jpg";